// @flow

import { call, fork, put, take } from 'redux-saga/effects'
import { GET_LEAGUES_ORGANIZATIONS, getLeaguesOrganizations } from 'src/redux/actions/leagues/leagues'
import http from 'src/services/http'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchGetLeaguesOrganizations(): Generator<IOEffect, void, any> {
  while (true) {
    yield take(GET_LEAGUES_ORGANIZATIONS.REQUEST)

    try {
      const { data } = yield call(http, 'admin/organizations', {
        method: 'GET',
      })

      yield put(getLeaguesOrganizations.success(data))
    } catch (e) {
      yield put(getLeaguesOrganizations.error(e.message))
    }
  }
}

export default [fork(watchGetLeaguesOrganizations)]
